import React from "react";
import Button from "./Button";

const IconButton = ({
  Icon,
  big = false,
  ...rest
}) => {
  if (!Icon)
    throw new Error('you must specify an icon');

  const paddingCls = big ? 'p-3.5' : 'p-2.5';
  return <Button {...{Icon, paddingCls, ...rest}} />
};

export default IconButton;
